import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/incms';
const baseEndpoint2 = 'v1/channels';

const IncmsService = {

  getLecAccountData( account, locale ) {
    return axios
      .get( `v1/incms-lec/${account}/account-data?locale=${locale}` )
  },

  getSupplyTypes( ) {
    return axios
      .get( `${baseEndpoint}/work-request/supply/types` )
  },

  getCustomerTypes( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/customer/types/${supplyType}` )
  },
 
  getCustomerNationalities( ) {
    return axios
      .get( `${baseEndpoint}/work-request/customer/nationalities` )
  },
  getCustomerDocumentTypes( customerType, supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/customer/${customerType}/document-types/${supplyType}` )
  },
 
  getBillDispatch( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/bills/dispatch/${supplyType}` )
  },

  getAppliances( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/appliances/${supplyType}` )
  },

  getDocuments( ) {
    return axios
      .get( `${baseEndpoint}/work-request/documents/new-connection` )
  },

 
  getCountries( ) {
    return axios
      .get( `${baseEndpoint}/work-request/countries` )
  },

  getProvinces( country ) {
    return axios
      .get( `${baseEndpoint}/work-request/countries/${country}/provinces` )
  },

  getCities( provincies, cityId ) {
    return axios
      .get( `${baseEndpoint}/work-request/provinces/${provincies}/cities/${cityId}` )
  },

  getLocalities( country, cities, provincies ) {
    return axios
      .get( `${baseEndpoint}/work-request/provinces/${provincies}/cities/${cities}/localities?countryCode=${country}` )
  },

  getStreet( country, cities, provincies, localities ) {
    return axios
      .get( `${baseEndpoint}/work-request/cities/${cities}/localities/${localities}/streets?countryCode=${country}&provinceId=${provincies}` )
  },

  getPremiseTypes( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/premise/types/${supplyType}` )
  },

  getPremiseTypesCategories( supplyType, premiseType ) {
    return axios
      .get( `${baseEndpoint}/work-request/premise/types/${premiseType}/category/${supplyType}` )
  },

  getActivities( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/activities/${supplyType}` )
  },

  getSubActivities( supplyType, activities ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/activities/${activities}/subactivities/${supplyType}` )
  },

  getBuildings( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/buildings/${supplyType}` )
  },

  getApplicationCapacity( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/applications-capacity/${supplyType}` )
  },

  getReadingFrequency( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/reading-frequency/${supplyType}` )
  },
  
  getServicePhase( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/service-phase/${supplyType}` )
  },
  
  getVoltage( supplyType ) {
    return axios
      .get( `${baseEndpoint}/work-request/contract/service-voltage/${supplyType}` )
  },

  save( data ) {
    return axios
      .post( `${baseEndpoint}/work-request/new-connection`, data )
  },

  formatFormDataBody( data ) {
    const formData = new FormData();

    _.forEach( data, ( value, key ) => {
      if( value ) formData.append( key, value );
    } );

    return formData;
  },
  sendFile( externalApiUrl , data ) {        
    return axios
      .post( `${externalApiUrl}public/file`, this.formatFormDataBody( data ), {
        headers: { Authorization: `{{iOpen-Token}}` }})
  },

  changeOwnership( data ) {
    return axios
      .post( `${baseEndpoint}/work-request/change-ownership`, data )
  },

  changeTenant( data ) {
    return axios
      .post( `${baseEndpoint}/work-request/change-ownership`, data )
  },

  powerUpgrade( data ) {
    return axios
      .post( `${baseEndpoint}/work-request/power-upgrade`, data )
  },

  customerByContractNumber( contractNumber ) {
    return axios
      .get( `${baseEndpoint}/work-request/customer-search/contract-number?contractNumber=${contractNumber}` )
  },

  customerByDocumentId( customerType, docType, docId ) {
    return axios
      .get( `${baseEndpoint}/work-request/customer-search/document-criteria?customerType=${customerType}&docId=${docId}&docType=${docType}` )
  },

};

export default IncmsService;



// WEBPACK FOOTER //
// ./services/IncmsNewConnService.js